import { render, staticRenderFns } from "./selectBU.vue?vue&type=template&id=55008384&"
import script from "./selectBU.vue?vue&type=script&lang=js&"
export * from "./selectBU.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports